import React, {useEffect, useRef} from "react";
import { useTranslation} from 'react-i18next';
import i18n from 'i18next'
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import flagDE from '../styles/flags/DE.svg'
import flagUS from '../styles/flags/US.svg'
import flagPL from '../styles/flags/PL.svg'

const flags = {
  "de": flagDE, 
  "en": flagUS,
  "pl": flagPL,
};

const locales = {
  en: { 
        title: 'English',
        icon: 'US.svg'
      },
  de: { 
      title: 'Deutsch',
      icon: 'DE.svg'
    },
    pl: { 
      title: 'Polski',
      icon: 'PL.svg'
    }
};

export const Navigation = (props) => {
  const { t } = useTranslation();  
  const wrapperRef = useRef(null);

  const handleLangChange = (locale) => {
    //Change the language  
    i18n.changeLanguage(locale);

    //Save the chnage to stotage
    if (localStorage.getItem("cookies") === "yes") localStorage.setItem("lang", locale);
  };

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target) && wrapperRef.current.className.includes("collapse in")) {
        document.getElementById("closeMenuEvent").click();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  const closeMenu = (e) => {
    if (wrapperRef.current && wrapperRef.current.className.includes("collapse in"))
      document.getElementById("closeMenuEvent").click();
  }

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#menu-content"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <span>KALLIDEUS</span>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="menu-content"
          ref={wrapperRef}
        >
          <ul className="nav navbar-nav navbar-right">
            <li style={{display: "none"}}>
              <button className="page-scroll" data-toggle="collapse" data-target="#menu-content" id="closeMenuEvent" />
            </li>            
            <li>
              <a href="#about" className="page-scroll" onClick={closeMenu}>
              {t("Menu.about")}
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll" onClick={closeMenu}>
              {t("Menu.team")}
              </a>
            </li>            
            <li>
              <a href="#stats" className="page-scroll" onClick={closeMenu}> 
                {t("Menu.benefits")}
              </a>
            </li>                         
            <li>
              <a href="#services" className="page-scroll" onClick={closeMenu}>
              {t("Menu.services")}
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll" onClick={closeMenu}>
              {t("Menu.gallery")}
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeMenu}>
              {t("Menu.contact")}
              </a>
            </li>         
            <li>
              <DropdownButton id="languge-selector" title={t("Menu.selectLanguage")} className="dropdown-btn">
                {Object.keys(locales).map((locale) => (
                    <Dropdown.Item key={locale} 
                                   as="button" 
                                   className="toolbar-menuItem"
                                   style={{ fontWeight: i18n.resolvedLanguage === locale ? 'bold' : 'normal' }} 
                                   type="submit" onClick={() => handleLangChange(locale)}>
                                    <img
                                      alt="United States"
                                      src={flags[locale]}
                                      width="25" height="15"
                                      style={{marginRight: "5px"}}
                                    />
                                    {locales[locale].title}
                    </Dropdown.Item>
                ))} 
              </DropdownButton>                    
            </li>
          </ul>
        </div>
      </div>      
    </nav>
  );
};

//<li>
//<a href="#testimonials" className="page-scroll">
//{t("Menu.customers")}
//</a>
//</li>

//            <li>
//              <a href="#features" className="page-scroll" onClick={closeMenu}> 
//                {t("Menu.features")}
//              </a>
//            </li>  


//<li>
//<DropdownButton id="dropdown-basic-button" title="Dropdown button">
//  <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
//  <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
//  <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
//</DropdownButton>
//</li>   

